module.exports = __webpack_public_path__ + "img/1F1F2-1F1FE.94ed3ce5.svg";